var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9987 2.66669V14.6667M3.9987 2.66669H11.332C11.6857 2.66669 12.0248 2.80716 12.2748 3.05721C12.5249 3.30726 12.6654 3.6464 12.6654 4.00002V12C12.6654 12.3536 12.5249 12.6928 12.2748 12.9428C12.0248 13.1929 11.6857 13.3334 11.332 13.3334H3.9987C3.82189 13.3334 3.65232 13.2631 3.52729 13.1381C3.40227 13.0131 3.33203 12.8435 3.33203 12.6667V3.33335C3.33203 3.15654 3.40227 2.98697 3.52729 2.86195C3.65232 2.73693 3.82189 2.66669 3.9987 2.66669Z",
    stroke: "#9099A8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66797 5.33331H10.0013",
    stroke: "#9099A8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66797 8H10.0013",
    stroke: "#9099A8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.747fdd6dc3499912b3230d3c048e46a4.svg";
export { ForwardRef as ReactComponent };